import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="navbar"
export default class extends Controller {
  static values = {
    expanded: Boolean,
  };

  static targets = ["mobileMenu"];

  toggle() {
    this.expandedValue = !this.expandedValue;
  }

  expandedValueChanged(value, oldValue) {
    if (value === oldValue) return;

    document.body.classList.toggle("overflow-hidden", value);
    this.mobileMenuTarget.classList.toggle("show", value);
  }
}
